import { createFileRoute } from '@tanstack/react-router'
import SettingsCatalogsPage from '@/components/pages/Settings/team/SettingsCatalogsPage/SettingsCatalogsPage'

export const Route = createFileRoute('/$workspaceName/$environment/team-settings/catalogs')({
  component: CatalogsSettingsRoute,
})

function CatalogsSettingsRoute() {
  return <SettingsCatalogsPage />
}
